var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Curriculum } from '@/models/Curriculum';
import ErrorHandler from '@/support/ErrorHandler';
let CurriculumForm = class CurriculumForm extends Vue {
    constructor() {
        super(...arguments);
        this.isUploading = false;
        this.isTakingTooLong = false;
        this.name = '';
        this.file = null;
        this.rules = {
            valid: false,
            name: [(v) => !!v || 'Name is required'],
        };
    }
    mounted() {
        //
    }
    inputChanged(event) {
        const files = event.target.files;
        if (files === null || !files.length) {
            return;
        }
        this.file = files[0];
    }
    create() {
        if (!this.file || !this.name) {
            return;
        }
        this.isUploading = true;
        new Curriculum()
            .create({ name: this.name, excel: this.file })
            .then((curriculum) => {
            if (curriculum.id) {
                this.$router.push('/curricula/' + curriculum.id);
            }
            else {
                this.isTakingTooLong = true;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.isUploading = false;
        this.isTakingTooLong = false;
        this.name = '';
        this.file = undefined;
    }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    isUploadingChanged(isUploading, wasUploading) {
        if (isUploading) {
            this.takingTooLongTimeout = setTimeout(() => {
                this.isTakingTooLong = true;
            }, 60000);
        }
        else {
            this.isTakingTooLong = false;
            clearTimeout(this.takingTooLongTimeout);
        }
    }
};
__decorate([
    Watch('isUploading'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], CurriculumForm.prototype, "isUploadingChanged", null);
CurriculumForm = __decorate([
    Component({})
], CurriculumForm);
export default CurriculumForm;
